module.exports = __webpack_public_path__ + "img/25.d3c81840.png";